<script>
export default {
  model: {
    event: 'update',
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    choices: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    addOnChange(choiceValue) {
      return {
        ...this.$attrs,
        onChange: (event) => {
          this.$emit('update', choiceValue)
          this.$emit('change', event)
        },
      }
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.label">{{ label }}</div>
    <label v-for="choice in choices" :key="choice.key">
      <BaseInputCheckbox
        :checked="propertiesSearchFilters.onlyOpenings"
        label="only openings"
        type="checkbox"
        @update="$emit(`update:${choice.key}`, choice.value)"
      />
    </label>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  margin-bottom: $size-grid-padding;

  input {
    display: inline-block;
    margin-left: $size-grid-padding * 0.25;
  }
}

.label {
  @extend %typography-label;

  color: $color-input-label;
}

.choice {
  text-align: left;
  cursor: pointer;

  input {
    margin-right: $size-grid-padding * 0.4;
    cursor: pointer;
  }
}
</style>
